module.exports = __webpack_public_path__ + "static/media/noData.ac59ef6a.svg";